import PTableColumn from '../src/table-column';

/* istanbul ignore next */
PTableColumn.install = function (Vue) {
    Vue.component(PTableColumn.name, PTableColumn);
};

export default PTableColumn;
